import { ExpensePaymentMethod } from "@common/utils/graphql";

const PAYMENT_METHOD_LABELS: Record<ExpensePaymentMethod, string> = {
  [ExpensePaymentMethod.HypercardBusiness]: "Hypercard Business",
  [ExpensePaymentMethod.HypercardPersonal]: "Hypercard Personal",
  [ExpensePaymentMethod.Manual]: "Manual",
};

export const formatPaymentMethod = (paymentMethod: ExpensePaymentMethod) =>
  PAYMENT_METHOD_LABELS[paymentMethod];
